import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';

function SidebarAd({ id, width = '200px', height = '250px', slot }) {
  const adRef = useRef(null);
  const pushedRef = useRef(false);

  useEffect(() => {
    // Only push ad once, after a short delay to ensure container has width
    if (slot && !pushedRef.current && adRef.current) {
      const timer = setTimeout(() => {
        try {
          if (window.adsbygoogle) {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            pushedRef.current = true;
          }
        } catch (e) {
          // Silently ignore AdSense errors (common during development)
          if (process.env.NODE_ENV === 'development') {
            console.warn('AdSense warning:', e.message);
          }
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [slot]);

  return (
    <Box
      id={id}
      className="sidebar-ad-container"
      sx={{
        background: '#fafafa',
        border: '1px solid #e0e0e0',
        padding: '8px',
        margin: 0,
        textAlign: 'center',
        overflow: 'hidden',
        width: width,
        maxWidth: width,
        borderRadius: '4px'
      }}
    >
      <Typography
        className="ad-label"
        sx={{
          fontSize: '7px',
          color: '#aaa',
          textTransform: 'uppercase',
          letterSpacing: '0.3px',
          margin: 0,
          marginBottom: '4px',
          lineHeight: 1,
        }}
      >
        Advertisement
      </Typography>
      <Box
        ref={adRef}
        className="ad-placeholder"
        sx={{
          height: height,
          maxHeight: height,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          margin: 0,
          padding: 0,
        }}
      >
        {slot ? (
          <>
            <style dangerouslySetInnerHTML={{__html: `
              .sidebar-ad-${id} {
                display: inline-block !important;
                width: ${width} !important;
                height: ${height} !important;
                max-height: ${height} !important;
                max-width: ${width} !important;
                overflow: hidden !important;
              }
            `}} />
            <ins
              className={`adsbygoogle sidebar-ad-${id}`}
              style={{ display: 'inline-block', width: width, height: height, maxWidth: width }}
              data-ad-client="ca-pub-1768446265734594"
              data-ad-slot={slot}
            />
          </>
        ) : (
          <Box
            sx={{
              background: '#f0f0f0',
              border: '1px dashed #ccc',
              height: height,
              maxHeight: height,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#999',
              fontSize: '10px',
              width: '100%',
              overflow: 'hidden',
            }}
          >
            <span>Ad Space</span>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default SidebarAd;
